module.exports = __webpack_public_path__ + "static/2front-development-3-8c7c85b65d2acd9fbdf96ac876b9c65d.png";